/**
 * Global slide-in cart drawer.
 * Opens from header cart icon and from trial-page Add to Cart / Buy Once.
 */
(function () {
  'use strict';

  function formatCartMoney(cents) {
    var value = Number(cents || 0) / 100;
    return '$' + value.toFixed(2);
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-tq-cart]');
    if (!drawer || drawer.getAttribute('data-tq-cart-ready') === 'true') return;
    drawer.setAttribute('data-tq-cart-ready', 'true');

    var body = drawer.querySelector('[data-tq-cart-body]');
    var foot = drawer.querySelector('[data-tq-cart-foot]');
    var subtotalEl = drawer.querySelector('[data-tq-cart-subtotal]');
    var closeEls = Array.prototype.slice.call(drawer.querySelectorAll('[data-tq-cart-close]'));
    var lastActive = null;
    var lastAddError = null;

    var MONITOR_VARIANT_ID = '49991529169178';
    var MONITOR_REGULAR_CENTS = 5000;
    var MONITOR_DISCOUNT_CENTS = 1500;
    var CANISTER_VARIANT_ID = '49702104531226';
    var CANISTER_REGULAR_CENTS = 500;

    function setOpen(open) {
      if (open) {
        drawer.removeAttribute('inert');
        drawer.setAttribute('data-open', 'true');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      } else {
        drawer.setAttribute('inert', '');
        drawer.removeAttribute('data-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    var TRASH_SVG =
      '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">' +
      '<path fill="currentColor" d="M9 3h6a1 1 0 0 1 1 1v1h4v2H4V5h4V4a1 1 0 0 1 1-1zm-3 6h12l-1 11a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 9zm3.5 2v9h1.5v-9H9.5zm4 0v9h1.5v-9h-1.5z"/>' +
      '</svg>';

    function isMonitorItem(item) {
      return (
        String(item.variant_id) === MONITOR_VARIANT_ID ||
        String(item.id) === MONITOR_VARIANT_ID
      );
    }

    function isCanisterItem(item) {
      return (
        String(item.variant_id) === CANISTER_VARIANT_ID ||
        String(item.id) === CANISTER_VARIANT_ID
      );
    }

    function isPowderDrinkMixItem(item) {
      var title = String(item.product_title || '').toLowerCase();
      return title.indexOf('powdered drink mix') !== -1;
    }

    /* Trial page selling plan IDs → cart drawer subscription subheaders */
    var MONTHLY_PLAN_IDS = {
      '10454303002': true,
      '11863327002': true,
      '10070360346': true
    };
    var QUARTERLY_PLAN_IDS = {
      '11863392538': true, /* Powder Pouch (canister bundle) 3-month */
      '11863425306': true, /* Powder Pouch alt variant 3-month */
      '11863359770': true,
      '11835736346': true
    };

    function subscriptionSubheadHtml(item) {
      var alloc = item && item.selling_plan_allocation;
      var plan = alloc && alloc.selling_plan;
      if (!plan) return '';
      var id = String(plan.id);
      var text = '';
      if (MONTHLY_PLAN_IDS[id]) {
        text = 'Delivered every 4 weeks';
      } else if (QUARTERLY_PLAN_IDS[id]) {
        text = 'Three deliveries, every 4 weeks';
      } else {
        var name = String(plan.name || '').toLowerCase();
        if (
          name.indexOf('three') !== -1 ||
          name.indexOf('3-month') !== -1 ||
          name.indexOf('3 month') !== -1 ||
          name.indexOf('quarter') !== -1
        ) {
          text = 'Three deliveries, every 4 weeks';
        } else if (name.indexOf('month') !== -1 || name.indexOf('4 week') !== -1) {
          text = 'Delivered every 4 weeks';
        }
      }
      if (!text) return '';
      return '<p class="tq-cart__subhead">' + escapeHtml(text) + '</p>';
    }

    function itemHtml(item, dealOpts) {
      dealOpts = dealOpts || {};
      var img = item.image ? item.image : '';
      var variant =
        item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="tq-cart__variant">' + escapeHtml(item.variant_title) + '</p>'
          : '';
      var subhead = subscriptionSubheadHtml(item);
      var isRemove = item.quantity <= 1;
      var decInner = isRemove ? TRASH_SVG : '&minus;';
      var decClass = 'tq-cart__qtybtn' + (isRemove ? ' tq-cart__qtybtn--remove' : '');
      var decLabel = isRemove ? 'Remove item' : 'Decrease quantity';
      var priceHtml;
      if (isMonitorItem(item) && dealOpts.monitorQualifies) {
        priceHtml =
          '<div class="tq-cart__price tq-cart__price--deal">' +
          '<span class="tq-cart__was">' + formatCartMoney(MONITOR_REGULAR_CENTS * item.quantity) + '</span>' +
          '<span class="tq-cart__now">' + formatCartMoney(MONITOR_DISCOUNT_CENTS * item.quantity) + '</span>' +
          '</div>';
      } else if (isCanisterItem(item) && dealOpts.canisterQualifies) {
        priceHtml =
          '<div class="tq-cart__price tq-cart__price--deal">' +
          '<span class="tq-cart__was">' + formatCartMoney(CANISTER_REGULAR_CENTS * item.quantity) + '</span>' +
          '<span class="tq-cart__now">FREE</span>' +
          '</div>';
      } else {
        priceHtml = '<div class="tq-cart__price">' + formatCartMoney(item.final_line_price) + '</div>';
      }
      return (
        '<div class="tq-cart__item" data-line-key="' + escapeHtml(item.key) + '" data-qty="' + item.quantity + '">' +
        (img
          ? '<div class="tq-cart__thumb"><img src="' + img + '" alt="" loading="lazy"></div>'
          : '<div class="tq-cart__thumb"></div>') +
        '<div class="tq-cart__info">' +
        '<p class="tq-cart__name">' + escapeHtml(item.product_title) + '</p>' +
        subhead +
        variant +
        '<div class="tq-cart__qtyctl">' +
        '<button type="button" class="' + decClass + '" data-tq-qty-dec aria-label="' + decLabel + '">' + decInner + '</button>' +
        '<span class="tq-cart__qtynum">' + item.quantity + '</span>' +
        '<button type="button" class="tq-cart__qtybtn" data-tq-qty-inc aria-label="Increase quantity">+</button>' +
        '</div>' +
        '</div>' +
        priceHtml +
        '</div>'
      );
    }

    function sectionHtml(title, items, dealOpts) {
      if (!items.length) return '';
      return (
        '<div class="tq-cart__section">' +
        '<p class="tq-cart__secttitle">' + title + '</p>' +
        items
          .map(function (it) {
            return itemHtml(it, dealOpts);
          })
          .join('') +
        '</div>'
      );
    }

    function shopHref() {
      return '/products/120-life-free-shipping';
    }

    function updateHeaderCartCount(cart) {
      var count = 0;
      if (cart) {
        if (typeof cart.item_count === 'number') {
          count = cart.item_count;
        } else if (cart.items && cart.items.length) {
          count = cart.items.reduce(function (sum, item) {
            return sum + (parseInt(item.quantity, 10) || 0);
          }, 0);
        }
      }
      var label = String(count);
      Array.prototype.forEach.call(document.querySelectorAll('.cart_count'), function (el) {
        el.textContent = label;
      });
      /* Keep theme cart state attributes in sync when present. */
      Array.prototype.forEach.call(document.querySelectorAll('.mini_cart, a.icon-cart, a.icon-bag'), function (link) {
        if (link.closest('[data-tq-cart]')) return;
        link.setAttribute('data-cart-count', label);
      });
      syncStickyCartBar(count);
    }

    function syncStickyCartBar(count) {
      var bar = document.querySelector('[data-tq-cart-sticky]');
      if (!bar) return;
      if (count > 0) {
        bar.removeAttribute('hidden');
        document.body.classList.add('tq-has-cart-sticky');
      } else {
        bar.setAttribute('hidden', '');
        document.body.classList.remove('tq-has-cart-sticky');
      }
      setContactUsHiddenForSticky(count > 0);
    }

    function setContactUsHiddenForSticky(hide) {
      var emailIcon = document.querySelector('img[alt="Email Icon"]');
      var candidates = [];
      if (emailIcon) {
        var node = emailIcon;
        for (var i = 0; i < 5 && node; i++) {
          if (node !== document.body && node !== document.documentElement) candidates.push(node);
          node = node.parentElement;
        }
      }
      Array.prototype.forEach.call(
        document.querySelectorAll(
          '#dummy-chat-button-iframe, #shopify-chat, #ShopifyChat, [id*="gorgias-chat"], [class*="gorgias-chat-messenger"]'
        ),
        function (el) {
          candidates.push(el);
        }
      );
      candidates.forEach(function (el) {
        if (!el || !el.style) return;
        if (hide) {
          if (!el.getAttribute('data-tq-contact-display-prev')) {
            el.setAttribute('data-tq-contact-display-prev', el.style.display || '');
          }
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.style.setProperty('pointer-events', 'none', 'important');
          el.setAttribute('aria-hidden', 'true');
        } else if (el.hasAttribute('data-tq-contact-display-prev')) {
          var prev = el.getAttribute('data-tq-contact-display-prev') || '';
          if (prev) el.style.display = prev;
          else el.style.removeProperty('display');
          el.style.removeProperty('visibility');
          el.style.removeProperty('pointer-events');
          el.removeAttribute('aria-hidden');
          el.removeAttribute('data-tq-contact-display-prev');
        }
      });
    }

    function renderCart(cart) {
      if (cart) updateHeaderCartCount(cart);
      var banner = lastAddError
        ? '<div class="tq-cart__error" role="alert">' + escapeHtml(lastAddError) + '</div>'
        : '';
      lastAddError = null;
      if (!cart || !cart.items || !cart.items.length) {
        body.innerHTML =
          banner +
          '<div class="tq-cart__empty">' +
          '<p class="tq-cart__empty-title">Your Cart Is Empty</p>' +
          '<p>Start building a simpler daily blood pressure routine.</p>' +
          '<a class="tq-btn tq-btn--primary" href="' + shopHref() + '" data-tq-cart-close data-tq-cart-shop>Shop 120/Life</a>' +
          '</div>';
        if (foot) foot.hidden = true;
        return;
      }
      var subs = [];
      var ones = [];
      var hasMonitor = false;
      var hasOther = false;
      var hasCanister = false;
      var hasSubscriptionPowderDrinkMix = false;
      cart.items.forEach(function (item) {
        if (isMonitorItem(item)) {
          hasMonitor = true;
        } else {
          hasOther = true;
        }
        if (isCanisterItem(item)) hasCanister = true;
        if (isPowderDrinkMixItem(item) && item.selling_plan_allocation) {
          hasSubscriptionPowderDrinkMix = true;
        }
        if (item.selling_plan_allocation) {
          subs.push(item);
        } else {
          ones.push(item);
        }
      });
      var dealOpts = {
        monitorQualifies: hasMonitor && hasOther,
        /* FREE canister only when Powdered Drink Mix is a subscription line. */
        canisterQualifies: hasCanister && hasSubscriptionPowderDrinkMix
      };
      body.innerHTML =
        banner +
        sectionHtml('Subscription', subs, dealOpts) +
        sectionHtml('One-Time Purchase', ones, dealOpts);
      if (subtotalEl) subtotalEl.textContent = formatCartMoney(cart.total_price);
      if (foot) foot.hidden = false;
    }

    function changeLine(key, quantity) {
      if (typeof fetch !== 'function') return;
      body.style.opacity = '0.6';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) {
          return r && r.ok ? r.json() : null;
        })
        .then(function (cart) {
          body.style.opacity = '';
          if (cart) renderCart(cart);
        })
        .catch(function () {
          body.style.opacity = '';
        });
    }

    body.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || typeof target.closest !== 'function') return;
      var incBtn = target.closest('[data-tq-qty-inc]');
      var decBtn = target.closest('[data-tq-qty-dec]');
      if (!incBtn && !decBtn) return;
      var itemEl = (incBtn || decBtn).closest('[data-line-key]');
      if (!itemEl) return;
      e.preventDefault();
      var key = itemEl.getAttribute('data-line-key');
      var qty = parseInt(itemEl.getAttribute('data-qty'), 10) || 1;
      var newQty = incBtn ? qty + 1 : qty - 1;
      if (newQty < 0) newQty = 0;
      changeLine(key, newQty);
    });

    function loadCart() {
      body.innerHTML = '<div class="tq-cart__loading"><p>Loading…</p></div>';
      if (foot) foot.hidden = true;
      if (typeof fetch !== 'function') {
        body.innerHTML = '<div class="tq-cart__empty"><p><a href="/cart">View your cart</a></p></div>';
        return;
      }
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) {
          return r && r.ok ? r.json() : null;
        })
        .then(function (cart) {
          renderCart(cart);
        })
        .catch(function () {
          body.innerHTML =
            '<div class="tq-cart__empty"><p>We couldn&rsquo;t load your cart. <a href="/cart">View cart</a></p></div>';
        });
    }

    function openDrawer() {
      lastActive = document.activeElement;
      setOpen(true);
      loadCart();
      var x = drawer.querySelector('.tq-cart__x');
      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(function () {
          if (x && typeof x.focus === 'function') x.focus();
        });
      } else if (x && typeof x.focus === 'function') {
        x.focus();
      }
    }

    function closeDrawer() {
      setOpen(false);
      if (lastActive && typeof lastActive.focus === 'function') lastActive.focus();
    }

    function wireAddButtons() {
      var addBtns = Array.prototype.slice.call(
        document.querySelectorAll('[data-tq-add-to-cart], [data-tq-buy-once-link]')
      );
      var giftBox = document.querySelector('[data-tq-gift]');
      var giftInput = giftBox ? giftBox.querySelector('input[type="checkbox"]') : null;
      var giftVariantId = giftBox ? giftBox.getAttribute('data-tq-gift-variant') : null;

      addBtns.forEach(function (btn) {
        if (btn.getAttribute('data-tq-cart-wired') === 'true') return;
        btn.setAttribute('data-tq-cart-wired', 'true');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var variantId = parseInt(btn.getAttribute('data-tq-variant-id'), 10);
          var sellingPlanRaw = btn.getAttribute('data-tq-selling-plan');
          var sellingPlan = sellingPlanRaw ? parseInt(sellingPlanRaw, 10) : 0;
          var items = [];
          if (variantId) {
            var item = { id: variantId, quantity: 1 };
            if (sellingPlan) item.selling_plan = sellingPlan;
            items.push(item);
          }
          /* Flavor-specific one-time addon (subscription Add to Cart only; not Buy Once). */
          var isBuyOnce = btn.hasAttribute('data-tq-buy-once-link');
          var addonRaw = !isBuyOnce ? btn.getAttribute('data-tq-addon-variant') : null;
          var addonId = addonRaw ? parseInt(addonRaw, 10) : 0;
          if (addonId) items.push({ id: addonId, quantity: 1 });
          if (giftInput && giftInput.checked && giftVariantId) {
            var giftId = parseInt(giftVariantId, 10);
            if (giftId) items.push({ id: giftId, quantity: 1 });
          }
          if (items.length && typeof fetch === 'function') {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ items: items })
            })
              .then(function (r) {
                if (r && r.ok) {
                  openDrawer();
                  return;
                }
                return (r ? r.json() : Promise.resolve(null))
                  .catch(function () {
                    return null;
                  })
                  .then(function (err) {
                    console.error('Add to cart failed:', err || (r && r.status), 'payload:', items);
                    lastAddError =
                      (err && (err.description || err.message)) ||
                      'This item could not be added to your cart. Please check the variant and subscription plan IDs.';
                    openDrawer();
                  });
              })
              .catch(function (err) {
                console.error('Add to cart network error:', err, 'payload:', items);
                lastAddError = 'Something went wrong adding to your cart. Please try again.';
                openDrawer();
              });
          } else {
            openDrawer();
          }
        });
      });
    }

    closeEls.forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    drawer.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || typeof target.closest !== 'function') return;
      if (target.closest('[data-tq-cart-close]')) closeDrawer();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') closeDrawer();
    });

    /* Header cart icon → open drawer instead of navigating to /cart */
    document.addEventListener(
      'click',
      function (e) {
        var target = e.target;
        if (!target || typeof target.closest !== 'function') return;
        var cartLink = target.closest('a.mini_cart, a.icon-cart, a.icon-bag');
        if (!cartLink) return;
        /* Only intercept primary header cart controls, not "View cart" inside the drawer. */
        if (cartLink.closest('[data-tq-cart]')) return;
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        openDrawer();
      },
      true
    );

    wireAddButtons();

    var stickyOpenBtn = document.querySelector('[data-tq-cart-sticky-open]');
    if (stickyOpenBtn) {
      stickyOpenBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    }

    /* Sync sticky bar if the page loaded with an existing cart. */
    if (typeof fetch === 'function') {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) {
          return r && r.ok ? r.json() : null;
        })
        .then(function (cart) {
          if (cart) updateHeaderCartCount(cart);
          /* Chat widgets often mount late — re-hide after a short delay. */
          setTimeout(function () {
            var bar = document.querySelector('[data-tq-cart-sticky]');
            setContactUsHiddenForSticky(!!(bar && !bar.hasAttribute('hidden')));
          }, 1200);
        })
        .catch(function () {});
    }

    window.TQCart = {
      open: openDrawer,
      close: closeDrawer,
      refresh: loadCart,
      wireAddButtons: wireAddButtons
    };
  }

  function onReady() {
    initCartDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
